<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
       <template slot="imageSlot" slot-scope="{ row }">
        <div style="display: flex; align-items: center">
          <el-popover placement="right-start" title="" trigger="hover">
            <div style="width: 250px; height: 250px">
              <el-image
                :src="`${row.image}`"
                style="width: 100%; height: 100%"
              >
                <el-image
                  slot="error"
                  :src="no_pic"
                  style="width: 100%; height: 100%"
                ></el-image>
              </el-image>
            </div>
            <el-image
              slot="reference"
              :src="`${row.image}`"
              style="width: 60px; height: 60px; margin-top: 5px"
            >
              <el-image
                slot="error"
                :src="no_pic"
                style="width: 60px; height: 60px; margin-top: 5px"
              ></el-image>
            </el-image>
          </el-popover>
        </div>
      </template>
      <template slot="titleSlot"  slot-scope="{row}">
        <el-tooltip effect="dark" :content="row.title" placement="top">
          <span class="line-ellipsis">{{ row.title }}</span>
        </el-tooltip>
      </template>
      <template slot="statusSlot" slot-scope="{row}">
        <span>{{statusMap[row.status]}}</span>
      </template>
       <template slot="extendVal1Slot" slot-scope="{row}">
        <span>{{statusMap[row.extendVal1]}}</span>
      </template>
      <template slot="beforeSalesPriceSlot" slot-scope="{row}">
        <span>{{row.salesPriceContent && row.salesPriceContent.beforeSalesPrice}}</span>
      </template>
      <template slot="afterSalesPriceSlot" slot-scope="{row}">
        <span>{{row.salesPriceContent && row.salesPriceContent.afterSalesPrice}}</span>
      </template>
      <template slot="errorMessageSlot" slot-scope="{row}">
        <el-tooltip popper-width="400px" class="item" effect="dark" :content="row.errorMessage" placement="top">
          <span class="line-ellipsis">{{row.errorMessage}}</span>
        </el-tooltip>
      </template>
      <template slot="beforeDistributorPriceSlot" slot-scope="{row}">
        <div v-if="row.distributorPriceContent && isSku" style="white-space: pre-wrap; line-height:15px">{{row.distributorPriceContent.beforeDistributorPrice}}</div>
        <span v-else>请按sku查看</span>
      </template>
      <template slot="afterDistributorPriceSlot" slot-scope="{row}">
        <div v-if="row.distributorPriceContent && isSku" style="white-space: pre-wrap; line-height:15px">{{row.distributorPriceContent.afterDistributorPrice}}</div>
        <span v-else>请按sku查看</span>
      </template>
      <template slot="operationSlot" slot-scope="{row}">
        <el-button type="link" @click="handleEvent(row.baseItemId)">编辑商品</el-button>
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import tableMixins from '@mixins/table-mixins';
import no_pic from "@/assets/images/no_pic.png";
import {SALES_PRICE_COL_LIST, DISTRIBUTION_PRICE_COL_LIST, COL_LIST} from './dictionnary'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
    isChannel: {
      type: String,
      default: 'add'
    },
    isSku: {
      type: String,
      default: ''
    }
  },
  mixins: [new tableMixins(208, {isSku: true})],
  components: {
    TableList,
  },
  data() {
    return {
      no_pic,
      statusMap:{
        0: '失败',
        1: '成功',
        2: '部分成功'
      }
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'distributorDetail']),
    cols(){
      if(this.isChannel == 'disPrice') {
       return DISTRIBUTION_PRICE_COL_LIST
      }else if(this.isChannel != 'salePrice') {
        return COL_LIST
      }
      return SALES_PRICE_COL_LIST;
    }
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    ...mapActions(['setRePublishRowData', 'setDisplayRePublishRowData', 'setDistributorDetail']),
    handleEvent(baseItemId) {
      this.$emit('edit', baseItemId)
    }
  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

</style>
